









import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryUserMemberChangeRecordList } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import {getUser} from '@/store/userStore'
import UserMemberChangeDetailDialog  from './components/UserMemberChangeDetailDialog.vue'

@Component({
  components: {
    VQuery,
    VTable,
    UserMemberChangeDetailDialog
  },
})
export default class UserMemberChangeRecord extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
    createTimeDaterange: []
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1
  private memberList = []
  private partnerList = []
  private user = getUser()

  // 查询条件
  private queryModels: Array<QueryModel> = [
    // { title: '渠道', param: 'channel' },
    { title: '用户ID', param: 'userId' },
    { title: '手机号', param: 'mobilePhone' },
    { title: '昵称', param: 'nickname' },
    { title: '姓名', param: 'name' },
    { title: '创建时间', param: 'createTimeDaterange', type: 'daterange', }
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [
  ]
  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '用户ID',width: 100, param: 'userId' },
    { title: '手机号',width: 120, param: 'mobilePhone' },
    { title: '昵称',width: 120, param: 'nickname' },
    { title: '姓名',width: 120, param: 'name' },
    { title: '原会员',width: 120, param: 'oldMemberName' },
    { title: '新会员',width: 120, param: 'newMemberName' },
    { title: '变更原因', overflow : true, param: 'changeMsg' },
    { title: '创建时间',width: 160, param: 'createTime', formatter: DateFormat },
    {
      title: '操作',
      width: 100,
      fixed:'right',
      operation: [
        { title: '查看详情', click: this.openDetail },
      ],
    },
  ]

  public async created() {
    this.loadData()
  }

  public openDetail(data:any){
    console.log("查看详情")
    const d = this.$refs.UserMemberChangeDetailDialog as  UserMemberChangeDetailDialog
    d.open(data.id)
  }


  public async loadData() {
    const param = this.getRequestParam()
    const result = await QueryUserMemberChangeRecordList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  private getRequestParam(){
    const param: any = { ...this.queryParam }
    if (param.createTimeDaterange.length >0) {
      param.createTimes = DateFormat(param.createTimeDaterange[0]) + ',' + DateFormat(param.createTimeDaterange[1])
    }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    return param
  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }

}
